import React from 'react'
import injectSheet from 'react-jss'
import styles from './discussion.styles'
import ContributionForm from '../../../../shared/contribution-form/contribution-form.container'
import DiscussionFeed from '../../../../shared/discussion-feed/discussion-feed.container'
import Spinner from 'pobble-components/dist/spinner'

const Discussion = ({ classes, pending }) => {
  return (
    <div className={classes.container}>
      <h2>Join the discussion</h2>
      {!pending && <ContributionForm />}
      <div className={classes.feed}>
        <DiscussionFeed />
        {pending && <Spinner className={classes.spinner} />}
      </div>
    </div>
  )
}

export default injectSheet(styles)(Discussion)
